// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore utils is in the parent dir
import axios from '@utils/axios';

import { AppointmentEmailTemplatesResponse } from 'hooks/useFetchEmailTemplates';
import { StopTypes } from 'types/Appointment';
import captureException from 'utils/captureException';

type CopyRequestApptEmailRequest = {
  body: string;
  subject: string;
  id?: number;
  templateType?: string;
  freightTrackingId?: string;
  stopType: StopTypes;
};

export async function copyRequestApptEmail(
  templateText: string,
  emailTemplates: AppointmentEmailTemplatesResponse,
  freightTrackingID: string,
  stopType: StopTypes
) {
  // Copy request appointment email data to API
  const copyRequestApptEmailData: CopyRequestApptEmailRequest = {
    body: templateText,
    subject: emailTemplates.appointmentRequestTemplate.subject,
    id: emailTemplates.appointmentRequestTemplate.id, // You can add an ID if the template has one
    templateType: emailTemplates.appointmentRequestTemplate.templateType,
    freightTrackingId: freightTrackingID,
    stopType: stopType,
  };
  try {
    await axios.post(
      `scheduling/email-copy/request-appt`,
      copyRequestApptEmailData
    );
    return { success: true };
  } catch (error) {
    captureException(error, { functionName: 'copyRequestApptEmail' });
    return {
      success: false,
      error: 'Failed to copy request appointment email',
    };
  }
}
